import React, { useEffect, useState } from 'react'
import NavbarContainer from '../components/Navbar/Navbar'
import ProductsListContainer from '../components/ProductsListContainer/ProductsListContainer'
import Footer from '../components/Footer/Footer'
import { Col, Container, Row } from 'react-bootstrap'
import { useLocation, useParams } from 'react-router-dom'
import axios from 'axios'
import { useSelector } from 'react-redux'

function ProductsList() {
  const { pathname } = useLocation();  
    const { id } = useParams(); 
  
  const ids = id!==undefined&&id.split("/").pop();
console.log(ids);

  const { currentLocal } = useSelector((state) => state.currentLocal);

  const [stock, setStock] = useState('')
  const [color, setColor] = useState('')
  const [size, setSize] = useState('')
  const [products, setProducts] = useState([])
    useEffect(() => {
const getData=async()=>{
  if(id){
  await axios
  .get(`https://nanosoft.technology/outlaw/api/products?category_id=${ids}`)
  .then(async (res) => {

        setProducts(res.data.data);

  })
  .catch((error) => {

    console.log(error.response.data);


  });
}else{
  try {
        const response = await axios.get(`https://nanosoft.technology/outlaw/api/products`)
        
        setProducts(response.data.data);
        
} catch (error) {
  
}
}
}
getData()
  }, [])


  useEffect(() => {
    window.scrollTo(0, 0);

  }, [pathname])


  const [show, setShow] = useState(false);


  return (
    <>
      <NavbarContainer />
      {/* <PageHeader title={'Collections'}/> */}
      <Container className='py-5 ' fluid>
        <Row className='mx-4 px-3 mb-4'>
          <Col md={4}>
          
          </Col>
                <Col md={4}>
          
          </Col>
                <Col md={4}>
<div className='d-flex justify-content-end'>
  <div>{products?.length} {currentLocal.home.products}</div>
</div>
          </Col>
          {/* <div className='d-flex justify-content-start'>
            <button className='border px-4 rounded'style={{fontSize:'16px'}}onClick={handleShow}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-funnel" viewBox="0 0 16 16">
                <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2z" />
              </svg>
              Filter
            </button>
            <Offcanvas show={show} onHide={handleClose}style={{position:"absolute",zIndex:100000000000000000000}}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Filter</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
        <FiltaratinBar 
      onStock={handleStockFromChild}
      onsize={handleSizeFromChild}
      onColor={handleColorFromChild}
      />        </Offcanvas.Body>
      </Offcanvas>
          </div> */}
        </Row>
        <Row className='mx-4 px-3'>
          {/* <Col md={3}>
      <FiltaratinBar 
      onStock={handleStockFromChild}
      onsize={handleSizeFromChild}
      onColor={handleColorFromChild}
      />
      
      </Col> */}
          <ProductsListContainer
            stock={stock}
            size={size}
            color={color}
          />

        </Row>
      </Container>
      <Footer />
    </>)
}

export default ProductsList